import {
  UPDATE_STATE,
  RESET_STATE,
} from "../../actions/refreshInspection/refreshInspectionActions";

const initialState = {
  refresh: false,
};

const refresh = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATE:
      return {
        refresh: true,
      };
    case RESET_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default refresh;
